import AppQRLinks from './AppQRLinks';

export default AppQRLinks;
